<template>
    <div class="select-users panel panel-default">
        <div class="panel-heading">
            <h3>Пользователи</h3>
        </div>

        <panel-search @search="search" placeholder="Введите фио, телефон или почту для поиска"></panel-search>

        <table class="table table-striped" id="result-form-search">
            <thead>
            <tr>
                <th></th>
                <th>ФИО</th>
                <th>Логин</th>
                <th>Телефон</th>
                <th>E-mail</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in users">
                <td>
                    <input type="checkbox"
                           :id="`id-${user.id}`"
                           v-model="selected_ids"
                           :value="user.id"
                    >
                    <label :for="`id-${user.id}`"><span></span></label>
                </td>
                <td>{{ user.full_name }}</td>
                <td>{{ user.login }}</td>
                <td>{{ user.phone }}</td>
                <td>{{ user.email }}</td>
            </tr>
            <tr v-if="users != null && users.length < 1">
                <td colspan="5">Поиск</td>
            </tr>
            </tbody>
        </table>
        <button class="load-more" v-if="next_page_url" @click="loadNextPage">Еще</button>

        <div class="panel-heading">
            <h3>Выбранные пользователи</h3>
        </div>
        <table class="table table-striped">
            <thead>
            <tr>
                <th></th>
                <th>ФИО</th>
                <th>Логин</th>
                <th>Телефон</th>
                <th>E-mail</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in selected_users">
                <td>
                    <input type="checkbox"
                           :id="`id-selected-${user.id}`"
                           v-model="selected_ids"
                           :value="user.id"
                           :name="name"
                    >
                    <label :for="`id-selected-${user.id}`"><span></span></label>
                </td>
                <td>{{ user.full_name }}</td>
                <td>{{ user.login }}</td>
                <td>{{ user.phone }}</td>
                <td>{{ user.email }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import axios from 'axios'
    import _ from 'lodash'

    export default {
        props: {
            name: {
                type: String,
                default: 'users[]',
            },
            selected: {
                type: Array,
                default: [],
            },
        },
        data(){
            return {
                selected_ids: _.map(this.selected, 'id'),
                selected_users: this.selected,
                q: '',
                loading_next_page: null,
                next_page_url: null,
            }
        },
        asyncComputed: {
            users() {
                return axios
                    .get('/api/users', {
                        params: {
                            q: this.q
                        }
                    })
                    .then(({data}) => {
                        this.next_page_url = data.next_page_url
                        return data.data
                    })
            },
        },
        methods: {
            search(q) {
                this.q = q
            },
            loadNextPage(e) {
                e.preventDefault()
                if (!this.loading_next_page) {
                    this.loading_next_page = axios
                        .get(this.next_page_url)
                        .then(({data}) => {
                            this.next_page_url = data.next_page_url
                            this.users = this.users.concat(data.data)
                        })
                        .finally(() => this.loading_next_page = null)
                }
            },
        },
        watch: {
            selected_ids(newValue, oldValue) {
                var addedIds = _.difference(newValue, oldValue, _.map(this.selected_users, 'id'))
                _.each(addedIds, id => {
                    var addedUser = _.find(this.users, u => u.id === id)
                    if (addedUser) {
                        this.selected_users.push(addedUser)
                    }
                })
            },
        }
    }
</script>

<style lang="less">
    @import "../../less/_boot";

    .select-users {
        border: 0;
        background-color: #fff;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
        .panel-search {
            background-color: @gray-lightest;
        }
    }
</style>



// WEBPACK FOOTER //
// SelectUsers.vue?6345aa35